<div class="main-container">
    <app-page-header [pageTitle]="expiredMoreThanThree ? 'MCT Application Form' : 'MCT Reinstatement Form (Instructional Skills Assessment)'"></app-page-header>


    <div [ngClass]="{'bannerMsg-container': status === 'REINSTATE_SUBMIT' || status === 'REINSTATE_REJECT'}">
        <topaz-banner class="alertBanner" *ngIf="status=== 'REINSTATE_SUBMIT'" [bannerType]="'success'" useIcon
            disableScrolling disableCloseButton>
            <div banner-content>
                <span class="topaz-banner-subcontent">
                    <b>Thank you for submitting your application to become a Microsoft Certified Trainer.</b>
                    <br />

                    Your application is under review, and additional information regarding next steps will be provided
                    via email within 3-5 business days.
                    <br />
                    For questions, please contact us at <a aria-label="Email MCT Support at mctpvsupport@pearson.com"
                        href="mailto:mctpvsupport@pearson.com">mctpvsupport&#64;pearson.com</a> - we’re here to help!
                </span>
            </div>
        </topaz-banner>

        <topaz-banner class="alertBanner" *ngIf="status=== 'REINSTATE_REJECT'" [bannerType]="'alert'" useIcon
            disableScrolling disableCloseButton>
            <div banner-content>
                <span class="topaz-banner-subcontent">
                    <b>Alert: Your application has been rejected</b>
                    <br />
                    Thank you for your interest in becoming a Microsoft Certified Trainer. Unfortunately, we are unable
                    to approve your application at this time.
                    <br />
                    This decision may be due to one or more eligibility requirements not being met. If additional detail
                    or clarification is needed, please contact our support team at <a aria-label="Email MCT Support at mctpvsupport@pearson.com"
                        href="mailto:mctpvsupport@pearson.com">mctpvsupport&#64;pearson.com</a> for guidance on
                    potential next steps.
                    <br />
                    We appreciate your interest in the Microsoft Certified Trainer program and encourage you to reapply
                    in the future when the eligibility criteria are met.
                </span>
            </div>
        </topaz-banner>
    </div>




    <div class="card-container">
        <mat-card class="renewal-card"> 
            <ng-container *ngIf="expiredMoreThanThree">
                <app-iltform [fromPortal]="'ALUMNI'" *ngIf="userSelectedFlow == 'ILTFlow'" [countryList]="countryList" [languageList]="languageList"></app-iltform>
                <app-iscpforms *ngIf="userSelectedFlow == 'ISCPFlow'" [countryList]="countryList"
                [languageList]="languageList"></app-iscpforms>
            </ng-container>

            <mat-stepper *ngIf="!expiredMoreThanThree && !isFTEuser" linear #stepperHorLin [orientation]="(stepperOrientation | async)!"
                id="linearHorizontalStepper">

                <ng-template matStepperIcon="edit" let-index="index">
                     <span aria-hidden="true"> {{ index + 1 }}</span>
                </ng-template>

                <mat-step [stepControl]="reinstatementStepOne">

                    <form [formGroup]="reinstatementStepOne">
                         <ng-template matStepLabel>
                            <span aria-label="1 MCT Personal Info">MCT Personal Info</span>
                        </ng-template>

                        <div class="grid-layout">
                            <div class="form-row">
                                <mat-form-field class="form-field-flex">
                                    <input type="text" placeholder="First Name*" matInput
                                        formControlName="firstname" />
                                    <mat-error
                                        *ngIf="!reinstatementStepOne.get('firstname')?.valid && reinstatementStepOne.get('firstname')?.touched && reinstatementStepOne.get('firstname')?.errors?.required">
                                        First name is required</mat-error>
                                    <mat-error
                                        *ngIf="reinstatementStepOne.get('firstname')?.touched && reinstatementStepOne.get('firstname')?.errors?.pattern">
                                        First name can contain letters only</mat-error>
                                </mat-form-field>
                                <mat-form-field class="form-field-flex">
                                    <input type="text" placeholder="Last Name*" matInput formControlName="lastname" />
                                    <mat-error
                                        *ngIf="!reinstatementStepOne.get('lastname')?.valid && reinstatementStepOne.get('lastname')?.touched && reinstatementStepOne.get('lastname')?.errors?.required">
                                        Last name is required</mat-error>
                                    <mat-error
                                        *ngIf="reinstatementStepOne.get('lastname')?.touched && reinstatementStepOne.get('lastname')?.errors?.pattern">
                                        Last name can contain letters only</mat-error>
                                </mat-form-field>
                            </div>

                            <mat-form-field>
                                <input type="text" placeholder="Email*" matInput formControlName="email" />
                                <mat-error *ngIf="!reinstatementStepOne.get('email')?.valid && reinstatementStepOne.get('email')?.touched && reinstatementStepOne.get('email')?.errors?.required">
                                    Email is required</mat-error>
                            </mat-form-field>
                            <mat-form-field>
                                <mat-select placeholder="Preferred Language*" formControlName="language">
                                    <mat-option *ngFor="let option of languageList" [value]="option.name">
                                        {{ option.name }}
                                    </mat-option>
                                </mat-select>
                                <mat-error>Language is required</mat-error>
                            </mat-form-field>

                            <mat-form-field>
                                <mat-select placeholder="Country*" formControlName="country"  (selectionChange)="onCountryChange($event)">
                                    <mat-option *ngFor="let option of countryList" [value]="option.countryName">
                                        {{ option.countryName }}
                                    </mat-option>
                                </mat-select>
                                <mat-error>Country is required</mat-error>
                            </mat-form-field>

                             <mat-form-field>
                                <mat-select placeholder="Timezone*" formControlName="timezone">
                                <mat-option *ngFor="let option of timezoneList" [value]="option.timeZone">
                                    {{ '(GMT' + option.utcOffset + ') ' + option.displayName }}
                                </mat-option>
                                </mat-select>
                                <mat-error *ngIf="!reinstatementStepOne.get('timezone')?.valid && reinstatementStepOne.get('timezone')?.touched && reinstatementStepOne.get('timezone')?.errors?.required">
                                                Select the Timezone</mat-error>
                            </mat-form-field>

                            <mat-form-field>
                                <mat-select placeholder="Employment Type*" formControlName="employmentType">
                                    <mat-option *ngFor="let option of employmentTypeList" [value]="option.value">
                                        {{ option.name }}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div class="step-action">
                            <button mat-flat-button color="primary" matStepperNext (click)="next()"
                                id="linearStep1Next">
                                Next
                            </button>
                        </div>
                    </form>
                </mat-step>

                <mat-step [stepControl]="reinstatementStepTwo">
                    <form [formGroup]="reinstatementStepTwo">
                       <ng-template matStepLabel>
                            <span aria-label="2 MCT Agreement">MCT Agreement</span>
                        </ng-template>
                        <div class="grid-layout">

                            <div class="topaz-checkbox-group-col">
                                 <p style="font-size: 13px; color: #595959; margin-bottom: 8px;margin-left:10px">
                                    <em>Note: You must review the MCT Program Agreement through the link below before you can check the box to accept it.</em>
                                 </p>
                                <div class="basic-checkboxes">
                                    <mat-checkbox matInput formControlName="mctAgreement"
                                        [(ngModel)]="isCheckboxSelected" [ngClass]="{
                                        'is-invalid': !isCheckboxSelected && formSubmitted }" class="white-check-icon"
                                        id="requiredCheckbox"
                                        style="--mdc-checkbox-selected-checkmark-color: white; --mat-checkbox-checkmark-color: white;">
                                    </mat-checkbox>
                                    <mat-error class="is-invalid no-top-margin"
                                        *ngIf="!isCheckboxSelected && formSubmitted">
                                        You must accept the Agreement to continue
                                    </mat-error>
                                    By checking this box, I acknowledge that I have read and agree to the terms of the <a style="width:670px" href="javascript:void(0)" (click)="agrementDoc()" (keydown.enter)="agrementDoc(); $event.stopPropagation()" aria-live="polite" [attr.aria-label]="'MCT Program Agreement (downloads PDF file, 150KB)'">MCT Program Agreement</a>
                                </div>
                            </div>
                        </div>
                        <div class="step-action">
                            <button class="blue-border-btn" mat-stroked-button matStepperPrevious
                                id="linearStep2Previous">
                                Previous
                            </button>

                            <button mat-flat-button color="primary" matStepperNext id="linearStep2Next"
                                (click)="submitReInstatementForm()" [disabled]="status == 'REINSTATE_SUBMIT'">
                                Submit
                            </button>
                        </div>
                    </form>
                </mat-step>
            </mat-stepper> 

            <ng-container *ngIf="!expiredMoreThanThree && isFTEuser">
                  <app-iscpforms [countryList]="countryList" [languageList]="languageList"></app-iscpforms>
            </ng-container>
        </mat-card>


        <div class="renewal-details">
            <mat-card aria-labelledby="short-card-title" appearance="outlined">
                <div class="note-container">
                    <div class="note-content">
                        <div class="note-title">Need help?</div>
                        <div class="note-description">
                            <p>
                                If you have any questions or need assistance, our support team is here to help.
                            </p>
                            <p>
                                <a aria-label="Email MCT Support at mctpvsupport@pearson.com" href="mailto:mctpvsupport@pearson.com">mctpvsupport&#64;pearson.com</a>
                            </p>
                        </div>
                    </div>
                </div>
            </mat-card>
        </div>
    </div>
</div>